import { useEffect, useState } from "react";
import { Share, Smartphone, X, PlusSquare, MoreVertical } from "lucide-react";

const KEY = "ihmj_a2hs_seen";

const isStandalone = () => window.matchMedia("(display-mode: standalone)").matches || window.navigator.standalone === true;
const isIOS = () => /iphone|ipad|ipod/i.test(navigator.userAgent);
const isMobile = () => window.matchMedia("(max-width: 640px)").matches && ("ontouchstart" in window || navigator.maxTouchPoints > 0);

export default function HomeScreenTip() {
  const [show, setShow] = useState(false);
  const [installEvt, setInstallEvt] = useState(null);

  useEffect(() => {
    if (localStorage.getItem(KEY) || isStandalone() || !isMobile()) return;
    const onPrompt = (e) => { e.preventDefault(); setInstallEvt(e); };
    window.addEventListener("beforeinstallprompt", onPrompt);
    const t = setTimeout(() => setShow(true), 2500);
    return () => { clearTimeout(t); window.removeEventListener("beforeinstallprompt", onPrompt); };
  }, []);

  const dismiss = () => { localStorage.setItem(KEY, "1"); setShow(false); };

  const install = async () => {
    if (!installEvt) return;
    installEvt.prompt();
    await installEvt.userChoice.catch(() => {});
    dismiss();
  };

  if (!show) return null;
  const ios = isIOS();

  return (
    <div className="fixed left-3 right-3 z-[60] bottom-[calc(4.75rem+env(safe-area-inset-bottom))] card-panel-elevated border-[#FD0F10]/50 p-4 rounded-xl shadow-2xl animate-in slide-in-from-bottom-4" data-testid="a2hs-tip">
      <button onClick={dismiss} className="absolute top-2 right-2 p-1.5 text-gray-400 hover:text-white" aria-label="Dismiss" data-testid="a2hs-dismiss"><X size={16}/></button>
      <div className="flex items-start gap-3">
        <div className="shrink-0 w-10 h-10 rounded-lg bg-black border border-[#2A2E39] flex items-center justify-center"><Smartphone size={20} className="text-[#FD0F10]"/></div>
        <div className="flex-1 min-w-0 pr-5">
          <div className="font-display font-bold text-white leading-tight">Keep your plan one tap away.</div>
          <p className="text-xs text-gray-300 mt-1">Pin this to your home screen. Opens like an app. No app store.</p>
          {ios ? (
            <ol className="mt-3 space-y-1.5 text-xs text-gray-100">
              <li className="flex items-center gap-2"><span className="font-mono-ui text-[#FD0F10]">1</span> Tap <Share size={13} className="inline text-[#FD0F10]"/> <span className="font-semibold">Share</span> at the bottom of Safari</li>
              <li className="flex items-center gap-2"><span className="font-mono-ui text-[#FD0F10]">2</span> Tap <PlusSquare size={13} className="inline text-[#FD0F10]"/> <span className="font-semibold">Add to Home Screen</span></li>
            </ol>
          ) : installEvt ? (
            <button onClick={install} className="mt-3 hero-accent text-white text-xs font-mono-ui uppercase tracking-wider px-4 py-2 rounded" data-testid="a2hs-install">Add to home screen</button>
          ) : (
            <ol className="mt-3 space-y-1.5 text-xs text-gray-100">
              <li className="flex items-center gap-2"><span className="font-mono-ui text-[#FD0F10]">1</span> Tap <MoreVertical size={13} className="inline text-[#FD0F10]"/> the browser menu</li>
              <li className="flex items-center gap-2"><span className="font-mono-ui text-[#FD0F10]">2</span> Tap <span className="font-semibold">Add to Home screen</span> or <span className="font-semibold">Install app</span></li>
            </ol>
          )}
          <button onClick={dismiss} className="mt-3 text-[11px] text-gray-400 underline" data-testid="a2hs-later">Not now</button>
        </div>
      </div>
    </div>
  );
}
